import camelCase from 'lodash/camelCase';
import each from 'lodash/each';

const urlPipe = '(?:[0-9a-z_-]+\\.)*';

/**
 * 判断合法的回调地址，只允许以http://、https://开头，并且域名是tradeup合法域名的完整url，或者以/开头的绝对地址url
 */
const tradeupDomains = [
    'tigerfintech\\.com', // 测试环境
    'tigerbrokers.net', // 测试环境
    'tradeup\\.com', // 线上品牌官网
    'ihuhoo\\.com', // 美国服务域名
    /**
     * @MATCH ipv4
     * 只允许测试环境使用ip和localhost
     */
    process.env.NODE_ENV === 'development' && '(?:\\d{1,3}\\.){3}\\d{1,3}',
    process.env.NODE_ENV === 'development' && 'localhost'
].filter(Boolean);
const legalURLModel = `(?:(?:https?://)?${urlPipe}(?:${tradeupDomains.join('|')})(?:\\:\\d{2,4})?(?:/.*)?|/[^/]+.*)`;

const regs = {
    // 支持中文域名邮箱
    email: '(?![\\-_.])[\\w\\-.]+@(?:(?![\\-_])[\\w\\-\u4e00-\u9fa5]{1,63}\\.)+[A-Za-z0-9]{2,}',

    phone: '\\+?[0-9]+-?[0-9]{3,18}(?:-[0-9]{1,8})?',

    cn: '[\u4e00-\u9fa5]+',

    chinaName: '[\u4e00-\u9fa5]{2,7}(?:\u00B7[\u4e00-\u9fa5]{1,7}){0,2}', // 买买提-啦啦啦

    mobile:
        '(?:12593|12520|10193|17900|17911|17951|125930|125200|101930|179000|179110|179510|\\+?86)?' +
        '1' +
        '[3456789]' +
        '[0-9]{9}',

    idcard: '[xX0-9]{18}',
    otherIdCard: '[a-zA-Z0-9]{5,30}',
    qq: '[0-9]{5,10}',
    number: '[0-9]+(?:\\.[0-9]+)?',
    version: '[0-9a-zA-Z]+(?:\\.[0-9a-zA-Z]+)*',
    pinyin: '[a-zA-Z]+',
    safeUrl: legalURLModel
};

const patterns = {};

each(regs, (pattern, name) => {
    const reg = new RegExp(`^${pattern}$`);

    patterns[camelCase(`is-${name}`)] = str => reg.test(str);
    patterns[name] = reg;
});

type Patterns<T, U extends string> = { [P in keyof T]: RegExp } & Record<U, (value: any) => boolean>;

export default patterns as Patterns<
    typeof regs,
    'isEmail' | 'isPhone' | 'isCn' | 'isChinaName' | 'isMobile' | 'isIdcard' | 'isNumber' | 'isPinyin' | 'isSafeUrl'
>;
